module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/home-desktop-app-a7854aab84484a5eda2783faee4f0bb2.png";